import { render, staticRenderFns } from "./scan-result.vue?vue&type=template&id=674c0b06&scoped=true&"
import script from "./scan-result.vue?vue&type=script&lang=js&"
export * from "./scan-result.vue?vue&type=script&lang=js&"
import style0 from "./scan-result.vue?vue&type=style&index=0&id=674c0b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c0b06",
  null
  
)

export default component.exports